module.exports = __webpack_public_path__ + "static/apple-ef16239f33616c21c1e43e56ade7f73e.svg";